import React from "react";
import Chart from "react-apexcharts";

export function HACCPChart5({ haccp }) {
  // 🔑 NORMALISASI DATA
  const data = Array.isArray(haccp)
    ? haccp
    : Array.isArray(haccp?.data)
      ? haccp.data
      : [];

  if (data.length === 0) {
    return <p className="text-muted">Memuat data chart...</p>;
  }

  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "Mei", "Jun",
    "Jul", "Aug", "Sep", "Okt", "Nov", "Des",
  ];

  const bulanList = [
    "jan", "feb", "mar", "apr", "mei", "jun",
    "jul", "aug", "sep", "okt", "nov", "des",
  ];

  const categories = monthNames.slice(0, 12);

  const getDataPerGrade = (grade) => {
    const item = data.find((row) => row.grade === grade);
    return bulanList.map((bln) => Number(item?.[bln] || 0));
  };

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        columnWidth: "45%",
        borderRadius: 5,
      },
    },
    legend: {
      position: "top",
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories,
    },
    tooltip: {
      y: {
        formatter: (val) => val.toLocaleString("id-ID"),
      },
    },
  };

  const chartSeries = [
    { name: "Grade A", data: getDataPerGrade("A") },
    { name: "Grade B", data: getDataPerGrade("B") },
    { name: "Grade C", data: getDataPerGrade("C") },
  ];

  return (
    <Chart
      options={chartOptions}
      series={chartSeries}
      type="bar"
      height={300}
    />
  );
}
